import { getValidSitecoreLink, ScLink } from 'components/SitecoreLink';
import { TEXT_COLORS } from 'design-system/colors';
import type { DigizuiteAsset } from 'models/asset';
import type {
	ColorField,
	Field,
	SitecoreBlockProps,
	SitecoreLink,
} from 'models/sitecore';
import { getAsset } from 'utils/helpers';

import TopBanner from './TopBanner';

interface Props extends SitecoreBlockProps {
	fields?: {
		color?: ColorField;
		heading?: Field<string>;
		link?: Field<SitecoreLink>;
		primaryImageDesktop?: Field<DigizuiteAsset[]>;
		primaryImageMobile?: Field<DigizuiteAsset[]>;
		secondaryImageDesktop?: Field<DigizuiteAsset[]>;
		secondaryImageMobile?: Field<DigizuiteAsset[]>;
		textColor?: ColorField;
	};
}

export default function TopBannerBlock({ fields }: Props) {
	if (!fields) {
		return null;
	}
	const link = getValidSitecoreLink(fields.link?.value);
	const bgColor = fields.color?.fields?.colorHex?.value;
	const textColor =
		fields.textColor?.fields?.colorHex?.value || TEXT_COLORS.negative;

	const primaryImageDesktop = getAsset(
		'Source Copy',
		fields.primaryImageDesktop,
	);
	const primaryImageMobile = getAsset('Source Copy', fields.primaryImageMobile);
	const secondaryImageDesktop = getAsset(
		'Source Copy',
		fields.secondaryImageDesktop,
	);
	const secondaryImageMobile = getAsset(
		'Source Copy',
		fields.secondaryImageMobile,
	);

	return (
		<TopBanner
			backgroundColor={bgColor}
			textColor={textColor}
			leftImageLargeSrc={primaryImageDesktop?.src}
			rightImageLargeSrc={secondaryImageDesktop?.src}
			leftImageSmallSrc={primaryImageMobile?.src}
			rightImageSmallSrc={secondaryImageMobile?.src}
		>
			{fields.heading?.value}
			{link && ' '}
			{link && (
				<ScLink link={link} underline>
					{link.text}
				</ScLink>
			)}
		</TopBanner>
	);
}
TopBannerBlock.displayName = 'TopBannerBlock';
